import { render, staticRenderFns } from "./P003.vue?vue&type=template&id=c9b98bb2"
import script from "./P003.vue?vue&type=script&lang=js"
export * from "./P003.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports